import { useNavigate } from 'react-router-dom'
import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { FilterBar } from '@/components/ui/data-table-customized'
import { paths } from '@/utils/path'
import { useProcessList } from '../../hooks/use-process-list'
import AddIcons from '@/icons/AddIcons'

const ProcessesList = () => {
    const navigate = useNavigate()

    const {
        processes,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        searchInputProps,
        columns,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
    } = useProcessList()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.warehouse,
                        title: 'Capacities & Resources',
                    },
                    {
                        path: paths.warehouseProcesses,
                        title: 'Processes',
                    },
                ]}
                actions={[
                    {
                        icon: <AddIcons />,
                        label: 'Create Process',
                        onClick() {
                            navigate(paths.warehouseProcessCreate)
                        },
                    },
                ]}
            />

            <Paper className="mt-2 space-y-2">
                <FilterBar
                    storageKey="warehouse-processes"
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={processes}
                        rowKey={(row) => row.id}
                        size="small"
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: 'Search processes...',
                            },
                            settings: {
                                show: true,
                                storageKey: 'warehouse-processes',
                                filterToggles,
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </>
    )
}

export default ProcessesList
